// extracted by mini-css-extract-plugin
module.exports = {"uploadImage":"uploadImage_2ZyH4QE-"};